const component = {
  template: `
    <div class="interval">
      <div class="interval__header">
        <img src="//cdn.startupmedia.com/greenback/misc/imgs/vacation-couple.jpg" class="interval__header__image" />
        <img src="//cdn.startupmedia.com/greenback/entities/{{$ctrl.id}}/logo.png" class="interval__header__logo" />
        <div class="interval__caption">
          <img src="//cdn.startupmedia.com/greenback/logos/gb-logo-icon-dark.png" class="interval__caption__logo" />
          travel
        </div>
      </div>
      <div class="interval__title">View Savings</div>
      <div class="interval__body">
        <div class="interval__item">
          <div class="interval__item__icon">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            	 viewBox="0 0 512.007 512.007" style="enable-background:new 0 0 512.007 512.007;" xml:space="preserve">
            <path style="fill:#CBD6E0;" d="M198.519,232.579l-74.88-75.184c0,0,0.608-19.792-14.112-16.416
            	c-14.736,3.376-35.152,26.048-36.832,32.528c-4.288,16.576,37.744,125.216,37.744,125.216l88.688-65.68"/>
            <path style="fill:#BBC7D1;" d="M116.119,159.395c-6.144,5.216-28.08,18.72-28.08,18.72s22.56-10.736,31.296-11.36
            	c8.752-0.608,46.336,32.848,46.336,32.848l0,0l-42.032-42.208c0,0,0.608-19.792-14.112-16.416
            	c-5.808,1.328-12.416,5.696-18.416,10.88c0.128-0.064,11.552-6.432,18.416-6.896C116.423,144.515,122.263,154.179,116.119,159.395z"
            	/>
            <path style="fill:#CBD6E0;" d="M317.175,167.171l-0.752-56.976c-0.016-0.96,0.32-1.888,0.96-2.592
            	c6.208-6.976,13.12-12.256,20.928-15.408c1.296-0.528,2.784-0.352,3.872,0.528c1.744,1.392,4.016,4.032,3.936,8.224l22.672,28.368
            	C368.807,129.315,351.767,154.227,317.175,167.171z"/>
            <path style="fill:#BBC7D1;" d="M346.135,100.947L346.135,100.947c-0.48,3.552-11.216,9.088-21.92,14.608c0,0,12.48-4.96,18.416-5.2
            	c5.936-0.24-7.056,40.96-25.488,52.384l0.064,4.432c34.576-12.944,51.616-37.856,51.616-37.856L346.135,100.947L346.135,100.947z"/>
            <path style="fill:#DAE5EF;" d="M0.039,421.555c-0.64,17.248,11.68,32.512,28.8,34.592c0.496,0.064,0.992,0.112,1.504,0.16
            	c24.544,2.144,59.536-0.928,121.84-39.28s165.104-119.68,196.096-150.688c30.992-30.992,69.664-74.576,75.184-100.96
            	s-13.2-42.656-77.648-15.04s-105.264,45.424-210.832,110.48s-88.992,65.984-103.728,89.616
            	C31.271,350.435,1.703,376.371,0.039,421.555z"/>
            <g>
            	<path style="opacity:0.4;fill:#FFFFFF;enable-background:new    ;" d="M0.023,421.555c-0.512,13.968,7.472,26.624,19.616,32.048
            		c69.392,6.816,64.656-36.928,53.024-40.688c-11.632-3.76-25.968-17.36,1.248-15.04s35.456-10.736,35.456-10.736
            		s-38.32,5.904-58.544-7.872c-20.24-13.792-19.552-28.832-19.552-28.832S1.703,376.371,0.023,421.555z"/>
            	<path style="opacity:0.3;fill:#FFFFFF;enable-background:new    ;" d="M314.087,174.995c-23.856,1.904-137.136,64.32-160.736,82.32
            		c-22.848,17.44-37.568,24.24-45.056,30.656c-22.224,17.744-15.936,30.304,0,18.656c0.912-0.736,146.464-101.6,198.144-127.968
            		C309.287,177.187,314.087,174.995,314.087,174.995z"/>
            </g>
            <path style="fill:#DAE5EF;" d="M337.847,157.251l10.592,4.992c0,0,37.04-22.944,59.568-25.408l-7.648-77.76
            	c-0.336-3.488-4.48-5.12-7.12-2.816l-20.304,17.728c-2.384,2.08-4.224,4.704-5.376,7.632L337.847,157.251z"/>
            <path style="fill:#CBD6E0;" d="M373.255,77.859l21.056-22.304l0,0c-0.384,0.176-0.736,0.4-1.072,0.688l-20.304,17.728
            	c-2.384,2.08-4.224,4.704-5.376,7.632l-29.696,75.616l10.592,4.992l22.736-80.688C371.559,80.163,372.279,78.899,373.255,77.859z"/>
            <path style="fill:#59A5E0;" d="M419.319,169.283c-10.848,26.864-34.816,36.896-34.816,36.896l-15.952,31.616
            	c0,0-116.928,93.296-162.96,126.432c-46.032,33.152-113.232,73.952-161.424,79.792c-22.384,2.704-34.576-1.744-41.2-7.28
            	c4.576,10.272,14.08,17.968,25.872,19.392c0.496,0.064,0.992,0.112,1.504,0.16c24.544,2.144,59.536-0.928,121.84-39.28
            	s165.104-119.68,196.096-150.688c29.52-29.52,65.952-70.416,74.144-97.056h-3.104V169.283z"/>
            <path style="fill:#65B1EF;" d="M77.287,435.843c-5.28,11.04-21.28,21.28-57.44,17.76h-0.16c-0.32-0.16-0.48-0.32-0.8-0.48
            	c-0.96-0.32-1.92-0.8-2.88-1.44c-2.88-1.76-5.44-4-7.68-6.56c-1.12-1.28-2.08-2.56-2.88-3.84c-0.96-1.44-1.6-2.88-2.4-4.32
            	c6.72,5.28,18.88,9.76,41.12,7.04C54.567,442.723,65.607,440.003,77.287,435.843z"/>
            <g>
            	<path style="fill:#3E4347;" d="M53.751,322.707c0,0-1.216,8.32,7.104,12.976c0,0-6.688,5.888-13.984,32.032
            		c0,0-9.44-7.984-10.144-17.024C36.023,341.635,53.751,322.707,53.751,322.707z"/>
            	<path style="fill:#3E4347;" d="M57.815,373.379c0,0,4.672-21.696,12.576-31.824c0,0,20.48,7.696,34.064,5.264
            		c0,0-2.032,20.064,0,29.2C104.439,376.019,77.479,381.699,57.815,373.379z"/>
            </g>
            <path style="fill:#DAE5EF;" d="M380.359,210.723c0,0-1.84-6.912,2.064-13.12c3.92-6.208,34.064-39.12,34.064-39.12l80.56-4.608
            	l2.576-2.448c1.296-1.232,3.024-1.92,4.816-1.92h0.56c3.872-0.016,7.008,3.12,7.008,6.992l0,0c0,1.856-0.736,3.632-2.048,4.944
            	l-16.016,16.016c-1.664,1.664-3.712,2.864-5.984,3.488L380.359,210.723z"/>
            <path style="fill:#CBD6E0;" d="M511.847,155.027c-0.672-3.152-3.472-5.52-6.832-5.52h-0.56c-1.792,0-3.52,0.688-4.816,1.92
            	l-2.576,2.448l-80.576,4.592l74.48-1.392c0,0-8.384,7.248-11.936,17.92c0,0,7.968-11.376,15.776-17.056
            	C502.631,152.243,507.271,148.131,511.847,155.027z"/>
            <path style="fill:#DAE5EF;" d="M212.199,357.475l230.672,1.024c4.336,0.016,8.544-1.408,11.968-4.064l39.216-30.4
            	c0,0,3.072-16.576-11.056-20.256c-14.112-3.68-20.256,5.52-20.256,5.52l-118.096-15.808c-8.304-1.104-16.24-4.176-23.136-8.944
            	l-23.264-16.08L212.199,357.475z"/>
            <path style="fill:#CBD6E0;" d="M482.999,303.779c-14.112-3.68-20.256,5.52-20.256,5.52l-118.096-15.808l112.752,22.624
            	c0,0-7.552,6.208-15.68,22.784c0,0,20.256-24.096,29.776-28.848c9.52-4.752,24.4-2.912,22.56,13.968
            	C494.055,324.035,497.127,307.459,482.999,303.779z"/>
            <g>
            </svg>

          </div>
          <div class="interval__item__caption">Air</div>
        </div>
        <div class="interval__item">
          <a href="https://www.leisuretimepassport.com/auth/travel/hotels-pl.html" class="interval__item__link">
            <div class="interval__item__icon">
              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
              <g>
              <rect y="166.4" style="fill:#E8EAEA;" width="113.067" height="345.6"/>
              <rect x="398.933" y="166.4" style="fill:#E8EAEA;" width="113.067" height="345.6"/>
              </g>
              <path style="fill:#FF7058;" d="M0,172.8L0,172.8h512l0,0c0-12.8-10.667-23.467-23.467-23.467H23.467C10.667,149.333,0,160,0,172.8z"
              />
              <rect x="113.067" y="108.8" style="fill:#F2F2F2;" width="285.867" height="403.2"/>
              <path style="fill:#FF7058;" d="M414.933,85.333H97.067c-6.4,0-11.733,5.333-11.733,11.733S90.667,108.8,97.067,108.8h317.867
              c6.4,0,11.733-5.333,11.733-11.733S421.333,85.333,414.933,85.333z"/>
              <g>
              <rect x="32" y="198.4" style="fill:#54C0EB;" width="49.067" height="54.4"/>
              <rect x="32" y="274.133" style="fill:#54C0EB;" width="49.067" height="54.4"/>
              <rect x="32" y="349.867" style="fill:#54C0EB;" width="49.067" height="54.4"/>
              <rect x="32" y="425.6" style="fill:#54C0EB;" width="49.067" height="54.4"/>
              <rect x="430.933" y="198.4" style="fill:#54C0EB;" width="49.067" height="54.4"/>
              <rect x="430.933" y="274.133" style="fill:#54C0EB;" width="49.067" height="54.4"/>
              <rect x="430.933" y="349.867" style="fill:#54C0EB;" width="49.067" height="54.4"/>
              <rect x="430.933" y="425.6" style="fill:#54C0EB;" width="49.067" height="54.4"/>
              </g>
              <rect x="145.067" y="293.333" style="fill:#84DBFF;" width="53.333" height="54.4"/>
              <rect x="198.4" y="378.667" style="fill:#40596B;" width="114.133" height="133.333"/>
              <rect y="489.6" style="fill:#ACB3BA;" width="512" height="22.4"/>
              <g>
              <rect x="145.067" y="141.867" style="fill:#84DBFF;" width="53.333" height="54.4"/>
              <rect x="145.067" y="217.6" style="fill:#84DBFF;" width="53.333" height="54.4"/>
              <rect x="229.333" y="141.867" style="fill:#84DBFF;" width="53.333" height="54.4"/>
              <rect x="229.333" y="217.6" style="fill:#84DBFF;" width="53.333" height="54.4"/>
              <rect x="229.333" y="293.333" style="fill:#84DBFF;" width="53.333" height="54.4"/>
              <rect x="313.6" y="141.867" style="fill:#84DBFF;" width="53.333" height="54.4"/>
              <rect x="313.6" y="217.6" style="fill:#84DBFF;" width="53.333" height="54.4"/>
              <rect x="313.6" y="293.333" style="fill:#84DBFF;" width="53.333" height="54.4"/>
              </g>
              <g>
              <path style="fill:#40596B;" d="M147.2,1.067h13.867V64H147.2V39.467h-25.6V64h-13.867V1.067H121.6v26.667h25.6L147.2,1.067
              L147.2,1.067z"/>
              <path style="fill:#40596B;" d="M229.333,55.467c-6.4,6.4-13.867,9.6-23.467,9.6s-17.067-3.2-23.467-9.6
              c-6.4-6.4-9.6-13.867-9.6-23.467s3.2-17.067,9.6-23.467C188.8,3.2,196.267,0,205.867,0c9.6,0,17.067,3.2,23.467,9.6
              c6.4,6.4,9.6,13.867,9.6,23.467C238.933,41.6,235.733,50.133,229.333,55.467z M225.067,33.067c0-5.333-2.133-10.667-5.333-14.933
              c-3.2-4.267-8.533-6.4-13.867-6.4s-9.6,2.133-13.867,6.4c-3.2,4.267-5.333,8.533-5.333,14.933S188.8,43.733,192,46.933
              c4.267,4.267,8.533,6.4,13.867,6.4c5.333,0,9.6-2.133,13.867-6.4S225.067,38.4,225.067,33.067z"/>
              <path style="fill:#40596B;" d="M276.267,13.867v51.2H262.4v-51.2h-18.133v-12.8H294.4V12.8h-18.133V13.867z"/>
              <path style="fill:#40596B;" d="M349.867,1.067v12.8h-32v12.8h28.8V38.4h-28.8v12.8h32V64h-46.933V1.067H349.867z"/>
              <path style="fill:#40596B;" d="M363.733,65.067v-64H377.6V51.2h26.667V64h-40.533V65.067z"/>
              </g>
              </svg>

            </div>
            <div class="interval__item__caption">Hotel</div>
          </a>
        </div>
        <div class="interval__item">
          <div class="interval__item__icon">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
            <path style="fill:#FF7058;" d="M300.8,124.267l81.067,97.067l77.867,11.733c21.333,3.2,37.333,21.333,37.333,42.667v83.2H6.4V251.2
            c0-17.067,13.867-29.867,29.867-29.867h23.467l71.467-96c4.267-5.333,10.667-8.533,17.067-8.533h135.467
            C291.2,116.8,297.6,120,300.8,124.267z"/>
            <path style="fill:#F2F2F2;" d="M0,339.733v19.2h498.133c7.467,0,13.867-6.4,13.867-13.867l0,0c0-7.467-6.4-13.867-13.867-13.867
            H7.467C3.2,331.2,0,335.467,0,339.733z"/>
            <g>
            <polygon style="fill:#FFFFFF;" points="100.267,222.4 192,222.4 192,148.8 154.667,148.8 	"/>
            <polygon style="fill:#FFFFFF;" points="280.533,148.8 224,148.8 224,222.4 341.333,222.4 	"/>
            </g>
            <circle style="fill:#40596B;" cx="98.133" cy="345.067" r="50.133"/>
            <circle style="fill:#F2F2F2;" cx="98.133" cy="345.067" r="22.4"/>
            <circle style="fill:#40596B;" cx="419.2" cy="345.067" r="50.133"/>
            <circle style="fill:#F2F2F2;" cx="419.2" cy="345.067" r="22.4"/>
            </svg>
          </div>
          <div class="interval__item__caption">Car</div>
        </div>
      </div>
    </div>
  `,
  bindings: {
    id: '@',
  },
  controller() {
    this.$onInit = () => {
    };
  }
};

export default component;



// WEBPACK FOOTER //
// ./js/containers/causePortal/components/interval/index.js